module.exports = __webpack_public_path__ + "img/domains-step-2.ru.bb38ffe1.png";